import apiClient from '@/plugins/axios';

export default {
	saveFile(fileData) {
		var formData = new FormData();
		formData.append('file', fileData.file);
		formData.append('CustomerId', fileData.customerId);

		if (fileData.documentType)
			formData.append('DocumentType', fileData.documentType);

		if (fileData.mapId) formData.append('MapId', fileData.mapId);

		if (fileData.flawId) formData.append('FlawId', fileData.flawId);

		if (fileData.buildingId)   formData.append('BuildingId', String(fileData.buildingId));

		return apiClient.post('v1/File', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},

	deleteFile(fileId) {
		return apiClient.delete(`v1/File/${fileId}`);
	},

	getFile(fileId) {
		return apiClient.get(`v1/File/${fileId}`, { responseType: 'blob' });
	},

	downloadFile(fileId) {
		return apiClient.get(`v1/File/${fileId}`, { responseType: 'arraybuffer' });
	},

	getFiles(params) {
		let query = '?';
		Object.entries(params).forEach(([key, value]) => {
			if (key === 'currentPage') {
				key = 'pageNumber';
			}

			query += value ? `${key}=${value}&` : '';
		});

		return apiClient.get(`v1/File${query}`);
	}
};
